export default "/images/b0b4df7c06d63d4ded3373279a91af7a.avif";